import { Component, Input } from "@angular/core";
import { DrawingEuroDto } from "app/models/dtos/drawing-euro.dto";

@Component({
    selector: 'drawing-euro-quotas',
    templateUrl: './euro-quotas.component.html',
    styleUrls: ['./euro-quotas.component.scss'],
})
export class DrawingEuroQuotas {
    @Input()
    euroRatings: DrawingEuroDto[];
}